/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-23 09:07:14
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 14:50:15
 */

import {Post} from "@/http/http";


import Bus from './bus';



/**
 *  新上传
 */
export var putObjectUseStream = (data): Promise<any> => {
    return Post(`/msls/PutObjectUseStream`, data);
};
/**上传图片**/
var upload = async function (file, name) {
    let filetype = name.substring(name.lastIndexOf('.') + 1);
    var storeAs = 'newcsp/' + getUuid() + '.' + filetype;
    try {
        let param = new FormData();
        const files = file;
        param.append('fileList', files);
        let resd = await Post(`/msls/oss/PutObjectUseStream`, param)
        let res:any = {
            res:{
                statusCode:'',
                requestUrls: []
            }
        }
        res.res.statusCode = '200'
        res.res.requestUrls = resd.extData
        return res
     
    } catch (error) {
        console.log(error);
    }
};

/**上传进度 */
var progress = function (p) {
    return function (done) {
        Bus.$emit('progress', Math.round(p * 100));
        done();
    };
};
/**重命名 */
var getUuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        })
        .toUpperCase();
};

export { upload };
